import { useEffect, useState } from 'react';
import { AccountContext } from './AccountContext';
import Api from '../api/Api';
import Translations from '../Translations';
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from "react-router-dom";
import App from "../App";

let loading = false;

export default function AccountProvider() {

	const [account, setAccount] = useState(null);

	useEffect(() => {
		if (window.location.pathname.substring(0, 7) == '/redir/')
			setAccount(false)
		else
			setAccount(getAccount())
	}, [])

	const getAccount = () => {
		if (loading) return false;
		loading = true;
		if (!account && hasCookie()) {
			Api.put('account/getaccount', null, response => {
				if (response.data.account) {
					login(response);
				} else {
					logout();
				}
			});
		} else
			return false;
	}

	const login = response => {
		if (response.data.account) {
			let account = response.data.account;
			setAccount(account);
			Translations.switchLanguage('cs');
			window.t.currencies = response.data.currencies;
		}
	}

	const logout = () => {
		document.cookie = 'XSRF-TOKEN_' + window.CONFIG.appname + '=;expires=Thu, 01 Jan 1970;path=' + (window.CONFIG.basename || '/');
		setAccount(false);
		Translations.switchLanguage('cs');
	}

	const hasCookie = () => {
		let name = 'XSRF-TOKEN_' + window.CONFIG.appname + "=";
		let ca = document.cookie.split(';');
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return false;
	}

	const router = createBrowserRouter(
		createRoutesFromElements(
			<Route path="*" element={< App />} />
		),
		{ basename: window.CONFIG?.basename || "" }
	);

	return (
		<AccountContext.Provider value={{ account, login, logout }}>
			<RouterProvider router={router}> </RouterProvider>
		</AccountContext.Provider>
	);
}